import Breadcrumb from '../../ui/components/Breadcrumb';
import HelpContactCard from '../../ui/components/HelpContactCard';
import MainContentArticle from '../../ui/components/MainContentArticle';
import MainSection from '../../ui/components/MainSection';
import MultiColorDivider from '../../ui/components/MultiColorDivider';
import SideBarNav from '../../ui/components/SideBarNav';
import PageTitle from '../buyerAndVendor/PageTitle';
import PoliciesMainContent from '../../ui/components/PoliciesMainContent';
import RefundsAndReturnPolicy from './RefundsAndReturnPolicy';

const routes = [
  { name: 'SmallSmall', href: '/' },
  { name: 'Support', href: '/' },
  { name: 'Refund&Returns', href: '/' },
];

export const dataContent = [
  { label: '1. Purpose and Scope', link: '#purpose-and-scope' },
  { label: '2. Definitions', link: '#definitions' },
  { label: '3. Eligibility for Returns', link: '#eligibility-for-returns' },
  { label: '4. Notification Timeline', link: '#notification-timeline' },
  {
    label: '5. Responsibility for Defective or Damaged Items',
    link: '#responsibility-for-defective-or-damaged-items',
  },
  { label: '6. Return Process', link: '#return-process' },
  { label: '7. Refunds and Replacements', link: '#refunds-and-replacements' },
  { label: '8. Exceptions', link: '#exceptions' },
  { label: '9. Platform-Specific Rules', link: '#platform-specific-rules' },
  { label: '10. Legal Provisions', link: '#legal-provisions' },
  {
    label: '11. Frequently Asked Questions (FAQ)',
    link: '#frequently-asked-questions-faq',
  },
  { label: '12. Contact Information', link: '#contact-information' },
];

function RefundsAndReturns() {
  // return <div>Refunds and Returns</div>;
  return (
    <PoliciesMainContent>
      <Breadcrumb routes={routes} />
      <PageTitle title="Refunds & Returns" />
      <MultiColorDivider />
      <MainSection>
        <SideBarNav title="Refunds and returns" data={dataContent} />
        <MainContentArticle title="SmallSmall Return and Refund Policy Introduction ">
          <p>
            At SmallSmall, we place the satisfaction of our customers at the
            core of everything we do. Whether you are purchasing a product,
            securing a rental home through, or using any of our other platforms
            and services, we want your experience to be seamless, secure, and
            reliable. This Return and Refund Policy outlines the rules,
            processes, and responsibilities of buyers, vendors, and delivery
            partners with respect to defective or damaged products, incorrect
            deliveries, return logistics, and refund procedures. This policy
            applies across all SmallSmall platforms and services, unless
            otherwise specified. It is designed to protect all parties involved,
            maintain accountability, and build long-term trust in our
            marketplace.
          </p>
          <RefundsAndReturnPolicy />
        </MainContentArticle>
      </MainSection>
      <HelpContactCard />
    </PoliciesMainContent>
  );
}

export default RefundsAndReturns;
